import React, { useEffect, useRef, useState } from "react";
import logo from "../../assets/images/logo-header.svg";
import { Link, useNavigate } from "react-router-dom";
import SideMenuBar from "../sideMenuBar/SideMenuBar";
import { useLocation } from "react-router-dom";
import icons from "../../assets/images/sprite-other-icons.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getFromLocalStorage,
  setToLocalStorage,
} from "../../services/helper/cl_Helper";
import { setSearchInput } from "../crashGames/cl_CrashSlice";
import { getUserLoyalty, setActiveItem, getRealBalance } from "../signIn/cl_SignInSlice";
import SearchScreen from "../home/SearchScreen";
import { setIsSideMenuOpened } from "../signUp/cl_SignUpSlice";
import LoyaltyConfig from "../../assets/loyaltyPointsConfig.json";
import { setIsmodalOpen, setShowLevelModal } from "../home/cl_LoyalltyCoins";
import { LevelModal } from "../Loyalty/LevelModal";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const buttonRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showLottery, setShowLottery] = useState(false);
  const { signInSuccess, userDetails, balance, userLoyalty } = useSelector(
    (state) => state?.signIn
  );
  const { isSideMenuOpened, signupSuccess } = useSelector(
    (state) => state?.signUp
  );
  const { isModalOpen, showLevelModal } = useSelector(
    (state) => state?.coinsHistory
  );
  const navigateTo = (route) => {
    navigate(`/${route}`);
  };
  const token = getFromLocalStorage("gk");
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setIsSideMenuOpened(false));
  }, [location.pathname]);

  const handleMenuClick = () => {
    setIsMenuOpen((prev) => !prev);
    dispatch(setIsSideMenuOpened(!isMenuOpen));
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && userDetails?.userId && token) {
        dispatch(getUserLoyalty(userDetails?.userId));
        dispatch(getRealBalance());
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [userDetails, userLoyalty?.level, dispatch, token]);

  const lastLevel = getFromLocalStorage("lastLevel");
  useEffect(() => {
    const lastLevel = getFromLocalStorage("lastLevel");
    if (userLoyalty?.level && userLoyalty.level !== lastLevel) {
      dispatch(setShowLevelModal(true));
      setToLocalStorage("lastLevel", userLoyalty.level);
      dispatch(setIsmodalOpen(true));
    }
  }, [userLoyalty?.level]);

  useEffect(() => {
    const header = document.querySelector(".SB-layout-header");
    if (header) {
      header.style.position = handleMenuClick ? "relative" : "sticky";
    }
  }, [handleMenuClick]);

  return (
    <div className="SB-mainHeader">
      <div className="SB-container">
        <div className="SB-mainHeader-container">
          {userLoyalty?.level && userLoyalty.level !== lastLevel && (
            <LevelModal />
          )}
          <div className="SB-mainHeader-leftSection">
            <div className="SB-mainHeader-logo">
              <Link
                to="/"
                onClick={() => {
                  // setIsSearchBoxOpen(false);
                  dispatch(setActiveItem(0));
                  dispatch(setSearchInput(""));
                }}
              >
                <img src={logo} alt="Fasfas Logo" />
              </Link>
            </div>
          </div>
          
          <div className="SB-mainHeader-rightSection">
            <SearchScreen />

            {signInSuccess || token || signupSuccess ? (
              <div
                className="SB-mainHeader-afterLogin"
                style={{ display: "block" }}
              >
                <div className="SB-mainHeader-afterLogin-right">
                  <button
                    className="SB-mainHeader-btnUserBalance"
                    id="SB-btnUserBalance"
                  >
                    <div className="SB-mainHeader-userDetails">
                      <div className="SB-mainHeader-userName d-none">
                        <div className="SB-mainHeader-userName-title">
                          {userDetails?.userName}
                        </div>
                      </div>
                      <div className="SB-mainHeader-userBalance">
                        KES {balance?.toLocaleString()}
                      </div>
                    </div>
                    <div
                      className="SB-iconSVG "
                      title="add icon"
                      onClick={() => navigateTo("deposit")}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg">
                        <use xlinkHref={`${icons}#${"icon-add"}`} />
                      </svg>
                    </div>
                  </button>

                  <div className="SB-dropdown SB-myAccountDropdown active">
                    {/* <button
                      className="SB-dropdown-btn SB-mainHeader-btnMyAccount"
                      onClick={() => dispatch(setIsSideMenuOpened(!isSideMenuOpened))}
                    >
                      <div className="SB-iconSVG " title="User Avatar">
                        <svg xmlns="http://www.w3.org/2000/svg">
                          <use xlinkHref={`${icons}#${"icon-user-avatar"}`} />
                        </svg>
                      </div>
                    </button> */}
                    <button
                      className="SB-dropdown-btn SB-mainHeader-btnMyAccount"
                      ref={buttonRef}
                      onClick={handleMenuClick}
                    >
                      {/* <img src="images/loyalty/vip.png" alt="vip"> */}
                      {userLoyalty?.lifeTimeCoins <=
                      LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                        .levelCutoff ? (
                        <img
                          src={require("../../assets/images/loyalty/dash.webp")}
                          alt="dash"
                        />
                      ) : userLoyalty?.lifeTimeCoins <=
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                          .levelCutoff ? (
                        <img
                          src={require("../../assets/images/loyalty/sprint.webp")}
                          alt="sprint"
                        />
                      ) : userLoyalty?.lifeTimeCoins <=
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                          .levelCutoff ? (
                        <img
                          src={require("../../assets/images/loyalty/surge.webp")}
                          alt="surge"
                        />
                      ) : userLoyalty.level === "level3" ? (
                        <img
                          src={require("../../assets/images/loyalty/thrill.webp")}
                          alt="thrill"
                        />
                      ) : userLoyalty.level === "level4" ? (
                        <img
                          src={require("../../assets/images/loyalty/boss.webp")}
                          alt="boss"
                        />
                      ) : (
                        ""
                      )}
                    </button>

                    {isSideMenuOpened ? (
                      <React.Fragment>
                        <SideMenuBar
                          buttonRef={buttonRef}
                          setIsMenuOpen={setIsMenuOpen}
                          isMenuOpen={isMenuOpen}
                        />
                      </React.Fragment>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="SB-form-group SB-msgCountBox d-none">
                  <a href="message-center.html">
                    <div className="SB-iconSVG">
                      <svg xmlns="http://www.w3.org/2000/svg">
                        <use xlinkHref={`${icons}#${"message"}`} />
                      </svg>
                    </div>
                    <span className="SB-badge">100</span>
                  </a>
                </div>
              </div>
            ) : (
              <div>
                <div className="SB-mainHeader-beforeLogin">
                  <div className="SB-mainHeader-loginRegister">
                    <button
                      className="btn SB-register SB-btnSmall"
                      data-toggle="modal"
                      data-target="SB-register-modal"
                    >
                      {" "}
                      <Link to="/signup">Sign Up</Link>
                    </button>
                    <button
                      className="btn SB-login SB-btnSmall"
                      data-toggle="modal"
                      data-target="SB-login-modal"
                    >
                      <Link to="/signin">Login</Link>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
